class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMegaMedia = window.matchMedia('(min-width: 990px)');
    this.closeDelay = null;
    this.bindMegaMenuHover();
  }

  bindMegaMenuHover() {
    if (!this.mainDetailsToggle.classList.contains('mega-menu')) return;

    const summary = this.mainDetailsToggle.querySelector('summary');

    summary?.addEventListener('click', (event) => {
      if (this.desktopMegaMedia.matches) {
        event.preventDefault();
      }
    });

    const openMegaMenu = () => {
      if (!this.desktopMegaMedia.matches) return;

      window.clearTimeout(this.closeDelay);

      document.querySelectorAll('header-menu details.mega-menu[open]').forEach((details) => {
        if (details !== this.mainDetailsToggle) {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      });

      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary?.setAttribute('aria-expanded', 'true');
      } else if (this.header) {
        this.header.preventHide = true;
        this.updateHeaderOverlayPosition();
      }
    };

    const scheduleClose = () => {
      if (!this.desktopMegaMedia.matches) return;

      window.clearTimeout(this.closeDelay);
      this.closeDelay = window.setTimeout(() => {
        if (!this.matches(':hover') && !this.mainDetailsToggle.contains(document.activeElement)) {
          this.close();
        }
      }, 150);
    };

    this.addEventListener('mouseenter', openMegaMenu);
    this.addEventListener('mouseleave', scheduleClose);
    this.addEventListener('focusin', openMegaMenu);

    this.desktopMegaMedia.addEventListener('change', () => {
      window.clearTimeout(this.closeDelay);
      if (!this.desktopMegaMedia.matches) {
        this.close();
      }
    });
  }

  updateHeaderOverlayPosition() {
    if (!this.header) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (!this.mainDetailsToggle.open) return;
    this.updateHeaderOverlayPosition();
  }
}

customElements.define('header-menu', HeaderMenu);
